import React from "react";
import { Card, CardBody, Row, Col, Progress } from "reactstrap";

const StudentAttendanceCard = ({ data }) => {
  if (!data) return null;

  return (
    <Card className="mb-4 shadow-sm border-0">
      <CardBody>
        <h5 className="fw-bold mb-3">Attendance Summary</h5>
        <Row>
          <Col md="4">
            <p><strong>Total Days:</strong> {data.totalDays}</p>
          </Col>
          <Col md="4">
            <p><strong>Present Days:</strong> {data.presentDays}</p>
          </Col>
          <Col md="4">
            <p><strong>Attendance %:</strong> {data.attendancePercentage}%</p>
          </Col>
        </Row>
        <Progress
          color={data.attendancePercentage >= 75 ? "success" : "warning"}
          value={data.attendancePercentage}
        />
      </CardBody>
    </Card>
  );
};

export default StudentAttendanceCard;
